import React, {useEffect, useState} from 'react';
import {KEYS} from '../../utils/Constants';
import {getData} from '../../utils/GeneralStorage';
import UI from './ui';

const PhoneVerificationSignup = ({navigation, ...props}) => {
  const [phoneNo, setPhoneNo] = useState('');

  useEffect(() => {
    getData(KEYS.phoneNumber).then(value => setPhoneNo(value));
  }, []);

  const uiProps = {
    navigation,
    phoneNo,
    ...props,
  };

  return <UI {...uiProps} />;
};

export default PhoneVerificationSignup;
